var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common_panel"},[_c('img',{attrs:{"src":require(`../../assets/img/YQTS/${_vm.LegendTextInfo.showText}.png`),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }